import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { PAGE_ROUTE_PATH, URL_PARAMS_KEY } from '@/constants';
import { useInternalRedirect } from '@/features/redirect';
import { useLoginUserInfo } from '@/hooks/useLoginUserInfo';

/**
 * 同時利用接続エラー カスタムフック
 */
export const useConnectionOverError = () => {
  const navigate = useNavigate();
  const { isSerialPlan } = useLoginUserInfo();
  const { internalRedirectToWelcome } = useInternalRedirect();

  /**
   * 同時利用接続エラーダイアログ用OKボタンのクリック処理
   */
  const clickConnectionOverErrorOKButton = useCallback(() => {
    if (isSerialPlan) {
      // シリアルで利用開始した場合はホーム画面に遷移
      navigate({
        pathname: PAGE_ROUTE_PATH.HOME,
      });

      return;
    }

    // ようこそ画面に遷移。このときホーム画面のパスを指定
    internalRedirectToWelcome(
      encodeURI(`${URL_PARAMS_KEY.WELCOME.path}=${PAGE_ROUTE_PATH.HOME}`),
    );
  }, [internalRedirectToWelcome, isSerialPlan, navigate]);

  return {
    clickConnectionOverErrorOKButton,
  };
};
